/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/Checkbox/theme';

export const CheckboxTheme = theme;
